import React from "react";

// The legacy (pre-Figma-spec) search box: a plain bordered input with a trailing
// magnifying-glass icon. Extracted from Site.jsx (CU-86cbfuvmx) where it was
// duplicated against SampleTable.jsx — this same markup exists in several other
// new_payments table components too, left as-is here since only Site.jsx's copy
// is in scope for that fix.
//
// @param {Object} props
// @param {string} props.value - Current search term.
// @param {(value: string) => void} props.onChange - Called with the new term string.
// @param {string} [props.placeholder]
const SearchInput = ({ value, onChange, placeholder = "Search" }) => (
  <div className="px-4">
    <div className="relative flex items-center" style={{ maxWidth: "220px" }}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ paddingTop: "0.44rem", paddingBottom: "0.44rem" }}
        className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <svg
          className="w-5 h-5 text-gray-700"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
);

export default SearchInput;
